var shouldHandleScroll = function shouldHandleScroll(event) {
  var _event$target = event.target,
      scrollHeight = _event$target.scrollHeight,
      scrollTop = _event$target.scrollTop,
      offsetHeight = _event$target.offsetHeight;
  var scrollPosition = scrollHeight - (scrollTop + offsetHeight);
  return scrollPosition < 50;
};

export default shouldHandleScroll;